<template>
  <div v-loading="isLoading"
      :style="loadingStyle"
      class="image-loader-loading">
    <img ref="image"
        class="image"
        :src="src"
        :style="imageStyle"
        @load="imageLoaded">
  </div>
</template>

<style>
.image-loader-loading {
  margin: auto;
  position: relative;
}
.image-loader-loading img {
  position: absolute;
}
.image-loader-loading .el-loading-mask .el-loading-spinner {
  display: flex;
  justify-content: center;
}
</style>

<script>
export default {
  name: 'ImageLoader',
  props: {
    src: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '200px'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      isLoading: true,
      imageHeight: 0,
      imageWidth: 0
    }
  },
  computed: {
    loadingStyle () {
      return { width: this.width, height: this.height }
    },
    imageStyle () {
      if (this.imageHeight > this.imageWidth) {
        return {
          height: this.height,
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)'
        }
      } else {
        return {
          width: this.width,
          top: '50%',
          left: 0,
          transform: 'translateY(-50%)'
        }
      }
    }
  },
  watch: {
    src () {
      this.isLoading = true
    }
  },
  methods: {
    imageLoaded: function (event) {
      if (this.$refs.image) {
        this.imageHeight = this.$refs.image.height
        this.imageWidth = this.$refs.image.width
      }
      this.isLoading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/ImageLoader.vue